<div *ngIf="!aktiv.ugyfelId" class="ures">
  <ion-icon name="business-outline"></ion-icon>
  Először válasszon ügyfelet az <b>Ügyfelek</b> fülön.
</div>

<ng-container *ngIf="aktiv.ugyfelId">
  <!-- A NAV M2M hitelesítője a Szervíz → NAV-kapcsolat képernyőn van (egy helyen az egész
       rendszerre) – itt csak az állapota látszik, beviteli mezők nélkül. -->
  <div class="adoszamla-beallitas">
    <h3><ion-icon name="server-outline"></ion-icon> NAV M2M hozzáférés
      <small>{{ be.konfiguralt ? '· beállítva' : '· nincs beállítva' }}</small>
      <button type="button" class="ov-gomb" style="margin-left:auto" (click)="navKapcsolatra()">
        <ion-icon name="link-outline"></ion-icon>{{ be.konfiguralt ? 'NAV-kapcsolat' : 'Beállítás' }}</button>
    </h3>
    <p class="halvany" style="margin:6px 4px 0">
      Adószám: <b>{{ be.adoszam8 || '—' }}</b>
      <ng-container *ngIf="be.van_m2m"> · gépi kapcsolat: <b>{{ be.kornyezet === 'teszt' ? 'TESZT' : 'éles' }}</b>{{ be.m2m_felhasznalo ? ' · ' + be.m2m_felhasznalo : '' }}</ng-container>
      <ng-container *ngIf="!be.van_m2m && be.van_ugyfelkapu"> · gépi kapcsolat nincs, <b>Ügyfélkapu (eBEV)</b> tartalékkal</ng-container>
      · Utolsó szinkron: {{ be.utolso_szinkron || '—' }}
      <ng-container *ngIf="!be.konfiguralt"><br>A gépi lekérdezéshez állítsd be a NAV-kapcsolatot (Szervíz → NAV-kapcsolat).</ng-container>
    </p>
    <div style="margin-top:8px; display:flex; gap:8px; align-items:flex-end; flex-wrap:wrap">
      <ion-item lines="none" style="--background:transparent; --min-height:auto; max-width:200px">
        <ion-label position="stacked">Lekérdezési dátum <small class="halvany">(opcionális)</small></ion-label>
        <ion-input type="date" [(ngModel)]="datumInput"></ion-input>
      </ion-item>
      <ion-button style="--background:var(--naplo)" (click)="szinkron()" [disabled]="!be.konfiguralt">
        <ion-icon slot="start" name="sync"></ion-icon> NAV adatok frissítése
      </ion-button>
      <ion-button fill="outline" (click)="nyitTeteles()" [disabled]="!be.adoszamla">
        <ion-icon slot="start" name="list"></ion-icon> Tételes adószámla
      </ion-button>
    </div>
    <p class="halvany" style="margin:4px 4px 0; font-size:.82em">
      A <b>lekérdezési dátum</b> megadásával a NAV azon nap állapota szerint adja az adószámlát (mint az eBEV-en).
      Üresen hagyva az aktuális állapotot kéri le.
    </p>
  </div>

  <!-- NAV-oldali üzemzavar / üzenet (pl. "A feldolgozás technikai okokból szünetel") -->
  <div class="nav-uzemzavar" *ngIf="navUzemzavar">
    <ion-icon name="warning-outline"></ion-icon>
    <div>
      <b>A NAV adószámla-szolgáltatása épp nem elérhető</b> (a hitelesítés sikeres, ez NAV-oldali üzemzavar – próbáld később).
      <div class="halvany" *ngIf="adoszamlaHiba">Adószámla: {{ adoszamlaHiba }}</div>
      <div class="halvany" *ngIf="tetelesHiba">Tételes adószámla: {{ tetelesHiba }}</div>
    </div>
  </div>

  <!-- Összegző kártyák -->
  <div class="adoszamla-kartyak" *ngIf="be.csokor">
    <div class="asz-kartya" [class.piros]="egyenleg != null && egyenleg > 0" [class.zold]="egyenleg != null && egyenleg <= 0">
      <div class="cim">Adószámla egyenleg</div>
      <div class="ertek">{{ egyenleg == null ? '—' : (egyenleg | number:'1.0-0') }} Ft</div>
      <div class="jel">{{ egyenleg == null ? '' : (egyenleg <= 0 ? 'túlfizetés / rendezett' : 'tartozás') }}</div>
    </div>
    <div class="asz-kartya" [class.piros]="hianyzoBevallasok.length" [class.zold]="!hianyzoBevallasok.length">
      <div class="cim">Hiányzó bevallások</div>
      <div class="ertek">{{ hianyzoBevallasok.length }} db</div>
      <div class="jel">{{ hianyzoBevallasok.length ? 'rendezendő' : 'nincs hiányzó' }}</div>
    </div>
    <div class="asz-kartya" [class.piros]="koztartozas > 0" [class.zold]="koztartozas <= 0">
      <div class="cim">Köztartozás</div>
      <div class="ertek">{{ koztartozas | number:'1.0-0' }} Ft</div>
      <div class="jel">{{ koztartozas > 0 ? 'fennálló' : 'nincs' }}</div>
    </div>
  </div>

  <!-- Hiányzó bevallások lista -->
  <div class="tabla-wrap" *ngIf="hianyzoBevallasok.length">
    <h4 class="szekcio">Hiányzó bevallások</h4>
    <table class="naplo-tabla">
      <thead><tr><th>Bevallás</th><th>Időszak</th><th>Határidő</th><th></th></tr></thead>
      <tbody>
        <tr *ngFor="let b of hianyzoBevallasok">
          <td>
            <b *ngIf="hianyzoKod(b)">{{ hianyzoKod(b) }}</b>
            <span class="halvany" *ngIf="hianyzoNev(b)"> · {{ hianyzoNev(b) }}</span>
            <span *ngIf="!hianyzoKod(b) && !hianyzoNev(b)">—</span>
          </td>
          <td>{{ hianyzoIdoszak(b) || '—' }}</td>
          <td>{{ hianyzoHatarido(b) || '—' }}</td>
          <td>
            <!-- Innen indítható a kitöltés: a sablon letöltésével és előtöltéssel együtt. -->
            <button type="button" class="ov-gomb" *ngIf="hianyzoMegnyithato(b)" (click)="kitoltes(b)"
                    title="A nyomtatvány létrehozása erre az időszakra – előtöltéssel, ha van miből">
              <ion-icon name="create-outline"></ion-icon>Kitöltés
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Bejelentett foglalkoztatottak -->
  <div class="tabla-wrap" *ngIf="foglalkoztatottak.length">
    <h4 class="szekcio">Bejelentett foglalkoztatottak ({{ foglalkoztatottak.length }})
      <small class="halvany">– a Bérszámfejtő „Alkalmazottak" fülén importálhatók</small>
    </h4>
    <table class="naplo-tabla">
      <thead><tr><th>Munkavállaló</th><th>Bejelentés</th><th>Óra</th><th>FEOR</th><th>Jogviszony kezdete</th><th>Jogviszony</th></tr></thead>
      <tbody>
        <tr *ngFor="let f of foglalkoztatottak">
          <td>{{ f.munkavallaloNeve }}</td>
          <td>{{ f.bejelentes?.length ? f.bejelentes[0].beerkezesDatuma : '—' }}</td>
          <td>{{ f.hetiOra?.length ? f.hetiOra[0].hetiMunkaora : '—' }}</td>
          <td>{{ f.feor?.length ? (f.feor[0].feorKod + ' – ' + f.feor[0].feorMegnevezes) : '—' }}</td>
          <td>{{ f.jogviszonyAlapadatok?.jogviszonyKezdete || '—' }}</td>
          <td>{{ f.jogviszonyAlapadatok?.jogviszonyKodMegnevezes || '—' }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="ures" *ngIf="!be.csokor && be.konfiguralt">
    <ion-icon name="cloud-download-outline"></ion-icon>
    Még nincs lekért NAV-adat. Kattints a <b>NAV adatok frissítése</b> gombra.
  </div>
</ng-container>

<!-- Tételes adószámla modal -->
<ion-modal #tetelesModal class="naplo-wide-modal">
  <ng-template>
    <ion-header><ion-toolbar class="naplo-toolbar" style="--background:var(--naplo); --color:#fff">
      <ion-title>Tételes adószámla</ion-title>
      <ion-buttons slot="end">
        <ion-button (click)="letoltTetelesPdf()" [disabled]="tetelesPdfBetolt" title="Letöltés PDF-ben">
          <ion-spinner *ngIf="tetelesPdfBetolt" name="dots"></ion-spinner>
          <ion-icon *ngIf="!tetelesPdfBetolt" slot="start" name="download-outline"></ion-icon>
          <span *ngIf="!tetelesPdfBetolt">PDF</span>
        </ion-button>
        <ion-button (click)="zarTeteles()"><ion-icon name="close"></ion-icon></ion-button>
      </ion-buttons>
    </ion-toolbar></ion-header>
    <ion-content class="ion-padding">
      <div *ngIf="tetelesOsszeg" class="teteles-osszeg" [class.piros]="egyenlegPiros(tetelesOsszeg)">
        Összesen: {{ tetelesOsszeg.osszeg | number:'1.0-0' }} Ft {{ tetelesOsszeg.minosites }}
      </div>
      <div *ngFor="let asz of tetelesAdonemek" class="adonem-blokk">
        <h4>{{ asz.kod }} {{ asz.megnevezes }} <small class="halvany">({{ asz.szamlaszam }})</small></h4>
        <div class="adonem-osszeg" *ngIf="asz.adonemEgyenleg">
          Kötelezettség: <b>{{ asz.kotelezettsegOsszesen | number:'1.0-0' }}</b> ·
          Pénzforgalom: <b>{{ asz.penzforgalomOsszesen | number:'1.0-0' }}</b> ·
          Egyenleg: <b [class.piros]="egyenlegPiros(asz.adonemEgyenleg)">{{ asz.adonemEgyenleg.osszeg | number:'1.0-0' }} Ft {{ asz.adonemEgyenleg.minosites }}</b>
        </div>
        <div class="tabla-wrap" *ngIf="asz.tetel?.length">
          <table class="naplo-tabla">
            <thead>
              <!-- A két oldal (mint a régi designban): kötelezettség | pénzforgalom – vastag elválasztóval -->
              <tr class="oldal-fejlec">
                <th colspan="3">Kötelezettség</th>
                <th colspan="2" class="oldal-hatar">Pénzforgalom</th>
              </tr>
              <tr>
                <th>Esedékesség</th><th>Megnevezés</th><th class="num">Előírás(+)/Jóváírás(−)</th>
                <th class="oldal-hatar">Teljesítés</th><th class="num">Befizetés(−)/Kiutalás(+)</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let t of asz.tetel">
                <td>{{ t.esedekessegiDatum || '—' }}</td>
                <td>{{ t.megnevezes || '—' }}</td>
                <td class="num">{{ t.kotelezettseg != null && t.kotelezettseg !== '' ? (t.kotelezettseg | number:'1.0-0') : '' }}</td>
                <td class="oldal-hatar">{{ t.teljesitesiDatum || '—' }}</td>
                <td class="num">{{ t.penzforgalom?.osszeg != null ? (t.penzforgalom.osszeg | number:'1.0-0') : '' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div *ngIf="!tetelesAdonemek.length" class="ures"><ion-icon name="document-outline"></ion-icon> Nincs tételes adatsor.</div>
    </ion-content>
  </ng-template>
</ion-modal>
